import type { Resource } from '../stores/resourcesStore';
import { POINTS } from './levelCalculation';

/**
 * Resource Stewardship economy XP (Ecological EC5) — a DERIVED view: tracking a
 * resource (a supply area, recycling, or a staff/service) is worth a little, and
 * each completed task (a restock, a recycling run, a staff job) is worth more.
 * The SAME value credits the Ecological domain (useUserStats) and the Resource
 * Stewardship area rank (useDisciplines) — credit-once, no re-mint. Pure.
 */
export const RESOURCE_ITEM_XP = 10;
export const RESOURCE_TASK_XP = 15;

export function computeResourcesEconomyXP(resources: Resource[]): number {
  // Config-backed (console → XP economy); the consts above are the defaults.
  const itemXP = POINTS.ECO_RESOURCE_ITEM ?? RESOURCE_ITEM_XP;
  const taskXP = POINTS.ECO_RESOURCE_TASK ?? RESOURCE_TASK_XP;
  let xp = resources.length * itemXP;
  for (const r of resources) {
    for (const t of r.tasks) {
      xp += Math.max(0, t.completionCount || 0) * taskXP;
    }
  }
  return xp;
}
